import {
  ajax
} from 'application/src/js/functions.js';
import Cropdate from './cropdate.js';

/**
 * @class
 * @param {number} args.rawmaterialid
 * @param {object} args.translations
 * @param {Mediator} args.mediator
 */
export default class Cropdates {
  constructor(args) {
    this.rawmaterialid = args.rawmaterialid;
    this.translations = args.translations;
    this.mediator = args.mediator;

    this.container = document.querySelector('.lp-content .cropdates');
    this.list = this.container.querySelector('.list');

    this.requestUrl = '/app/ajax/ajaxLoadRelatedCropDate';
    this.user = null;
    this.debugMode = true;
    this.hideClass = 'hide';

    this.load()
      .then(response => {
        this.user = response.user;
        this.render(response.data);
        this.mediator.publish('finishedLoading');
      })
      .catch(e => {
        if (this.debugMode && e) console.log(e);
        this.mediator.publish('finishedLoading');
      });
  }

  load() {
    this.mediator.publish('startedLoading');

    return ajax(this.requestUrl, {
      rawmaterialid: this.rawmaterialid,
      per_page: 10,
      per_index: 0,
      sort_by: 'start_date',
    });
  }

  render(cropdates) {
    // display only even amount of cropdates
    if (cropdates.length % 2 > 0) cropdates.pop();

    if (cropdates.length) this.container.classList.remove(this.hideClass);
    this.list.innerHTML = '';

    cropdates.map(data => {
      const cropElement = document.createElement('div');
      this.list.insertAdjacentElement('beforeend', cropElement);

      new Cropdate({
        parent: this,
        data: data,
        element: cropElement,
        translations: this.translations,
        user: this.user
      });
    });
  }
}